import { render, staticRenderFns } from "./TNotifications.vue?vue&type=template&id=37ed07fa"
import script from "./TNotifications.vue?vue&type=script&lang=js"
export * from "./TNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports